import { createContext } from 'react';
export const EditorConfigContext = /*#__PURE__*/createContext({});
EditorConfigContext.displayName = 'EditorConfigContext';